/** V2 — Écrans LOGEMENT / CRÉDITS / CHARGES. */
import { LOGEMENTS, BIEN_ACTUEL, CREDIT_TYPES } from "./simConstants";
import { BigButton, ChoiceCard, Chips, YesNo, StepTitle, SubLabel, AmountInput } from "./SimPrimitives";

export function StepLogement({ draft, patch, next }) {
  const s = draft.logement_statut;
  const ok = s && (s !== "locataire" || Number(draft.loyer_actuel) > 0) && (s !== "proprietaire" || !!draft.bien_actuel);
  return (
    <div>
      <StepTitle emoji="🏠" title="Actuellement, vous êtes…" />
      <div className="grid grid-cols-2 gap-2.5">
        {LOGEMENTS.map((o) => (
          <ChoiceCard key={o.key} compact selected={s === o.key} emoji={o.emoji} label={o.label} testid={`sim-logement-${o.key}`}
            onClick={() => { patch({ logement_statut: o.key, bien_actuel: null }); if (o.key === "heberge" || o.key === "autre") setTimeout(next, 160); }} />
        ))}
      </div>
      {s === "locataire" && (<><SubLabel>Loyer mensuel actuel</SubLabel><AmountInput value={draft.loyer_actuel} onChange={(x) => patch({ loyer_actuel: x })} suffix="€/mois" testid="sim-loyer-input" autoFocus />
        <p className="text-[11.5px] text-slate-500 mt-1.5">Ce loyer disparaît si vous achetez votre résidence principale — il n'est pas compté comme une charge future.</p></>)}
      {s === "proprietaire" && (<><SubLabel>Ce bien sera…</SubLabel><Chips options={BIEN_ACTUEL} value={draft.bien_actuel} onChange={(k) => patch({ bien_actuel: k })} testid="sim-bien-actuel" cols={1} /></>)}
      {(s === "locataire" || s === "proprietaire") && <div className="mt-8"><BigButton onClick={next} disabled={!ok} testid="sim-logement-next">Suivant →</BigButton></div>}
    </div>
  );
}

export function StepCredits({ draft, patch, next }) {
  const credits = draft.credits || [];
  const setAt = (i, p) => patch({ credits: credits.map((c, j) => (j === i ? { ...c, ...p } : c)) });
  const ok = draft.has_credits === false || (credits.length > 0 && credits.every((c) => Number(c.mensualite) > 0));
  return (
    <div>
      <StepTitle emoji="💳" title="Avez-vous des crédits en cours ?" />
      <YesNo value={draft.has_credits} testid="sim-credits"
        onChange={(v) => { patch({ has_credits: v, credits: v ? (credits.length ? credits : [{ type: "consommation", mensualite: "", fin_moins_12m: null, crd: "" }]) : [] }); if (v === false) setTimeout(next, 160); }} />
      {draft.has_credits === true && (
        <>
          <div className="space-y-3 mt-5">
            {credits.map((c, i) => (
              <div key={i} className="rounded-2xl bg-white border border-slate-200 p-3" data-testid={`sim-credit-${i}`}>
                <div className="flex items-center justify-between mb-2">
                  <span className="text-[11px] uppercase tracking-wider text-slate-500 font-bold">Crédit {i + 1}</span>
                  {credits.length > 1 && <button type="button" onClick={() => patch({ credits: credits.filter((_, j) => j !== i) })} className="text-slate-400 text-xs font-bold" data-testid={`sim-credit-${i}-remove`}>Retirer</button>}
                </div>
                <Chips options={CREDIT_TYPES} value={c.type} onChange={(k) => setAt(i, { type: k })} testid={`sim-credit-${i}-type`} cols={2} />
                <div className="mt-2"><AmountInput small value={c.mensualite} onChange={(x) => setAt(i, { mensualite: x })} suffix="€/mois" placeholder="Mensualité" testid={`sim-credit-${i}-mensualite`} /></div>
                <div className="mt-2 text-[12px] font-bold text-slate-600 mb-1">Se termine dans moins d'un an ?</div>
                <Chips options={[{ key: "oui", label: "Oui" }, { key: "non", label: "Non" }]} value={c.fin_moins_12m == null ? null : c.fin_moins_12m ? "oui" : "non"} onChange={(k) => setAt(i, { fin_moins_12m: k === "oui" })} testid={`sim-credit-${i}-fin`} cols={2} />
                {c.type === "immobilier" && (<><div className="mt-2 text-[12px] font-bold text-slate-600 mb-1">Capital restant dû <span className="text-slate-400">(facultatif)</span></div>
                  <AmountInput small value={c.crd} onChange={(x) => setAt(i, { crd: x })} testid={`sim-credit-${i}-crd`} /></>)}
              </div>
            ))}
          </div>
          <button type="button" onClick={() => patch({ credits: [...credits, { type: "consommation", mensualite: "", fin_moins_12m: null, crd: "" }] })}
            className="mt-3 w-full min-h-[46px] rounded-xl border-2 border-dashed border-slate-300 text-slate-600 text-[13px] font-bold" data-testid="sim-credit-add">+ Ajouter un crédit</button>
          <div className="mt-6"><BigButton onClick={next} disabled={!ok} testid="sim-credits-next">Suivant →</BigButton></div>
        </>
      )}
    </div>
  );
}

export function StepPension({ draft, patch, next }) {
  const ok = draft.has_pension === false || Number(draft.pension_alimentaire) > 0 || Number(draft.autres_charges) > 0;
  return (
    <div>
      <StepTitle emoji="👨‍👧" title="Versez-vous une pension alimentaire ou d'autres charges régulières ?" />
      <YesNo value={draft.has_pension} testid="sim-pension" onChange={(v) => { patch({ has_pension: v }); if (v === false) setTimeout(next, 160); }} />
      {draft.has_pension === true && (
        <>
          <SubLabel>Pension alimentaire versée</SubLabel>
          <AmountInput small value={draft.pension_alimentaire} onChange={(x) => patch({ pension_alimentaire: x })} suffix="€/mois" testid="sim-pension-amount-input" autoFocus />
          <SubLabel>Autres charges bancaires <span className="text-slate-400 font-semibold">(facultatif)</span></SubLabel>
          <AmountInput small value={draft.autres_charges} onChange={(x) => patch({ autres_charges: x })} suffix="€/mois" testid="sim-autres-charges-input" />
          <div className="mt-8"><BigButton onClick={next} disabled={!ok} testid="sim-pension-next">Suivant →</BigButton></div>
        </>
      )}
    </div>
  );
}
